import React from 'react';
import styles from '../../styles/Footer.module.scss';
import { Link } from 'react-router-dom';
import LOGO from '../../images/logo.webp';

const Footer = () => {
  return (
    <section className={styles.footer}>
     <div className={styles.logo}>
        <Link to='/'>
          <img src={LOGO} alt='logo' />
          <div className={styles.logoText}>
          <h3>ARKDetali</h3>
          <span>Brake Systems</span>
          </div>
        </Link>
      </div>
      <div className={styles.rights}>ARKDetali-2018</div>
      <div className={styles.socials}>
      <a href="https://instagram.com" target="_blank" rel="noreferrer">
        <svg className="icon">
          <use xlinkHref={`${process.env.PUBLIC_URL}/sprite.svg#instagram`} />
        </svg>
      </a>

      <a href="https://facebook.com" target="_blank" rel="noreferrer">
        <svg className="icon">
          <use xlinkHref={`${process.env.PUBLIC_URL}/sprite.svg#facebook`} />
        </svg>
      </a>

      <a href="https://youtube.com" target="_blank" rel="noreferrer">
        <svg className="icon">
          <use xlinkHref={`${process.env.PUBLIC_URL}/sprite.svg#youtube`} />
        </svg>
      </a>
    </div>
    </section>
  )
}

export default Footer
